import http from '@services/http'

export default {
  getJournalList(data: any): Promise<any> {
    return http.post('editor-api/journal/list', data || {})
  },

  getJournalDetail(data: any): Promise<any> {
    return http.post(`editor-api/journal/detail`, data || {})
  },

  editJournal(data: any): Promise<any> {
    return http.post('editor-api/journal/edit', data || {})
  },

  getEditorDetail(data: any): Promise<any> {
    return http.post('editor-api/editor/detail', data || {})
  },

  editEditor(data: any): Promise<any> {
    return http.post('editor-api/editor/edit', data || {})
  },

  changePass(data: any): Promise<any> {
    return http.post('editor-api/editor/changePass', data || {})
  }
}
